import { useTranslation } from 'react-i18next';
import { useAppSelector } from 'setup/store';
import ErrorBox from 'components/lib/error-box';
import { useNavigate, useParams } from 'react-router-dom';
import UserDataForm from 'components/user/user-data-form/UserDataForm';
import { Alert, Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { UserRolePriority, UserRoleTypeEnum } from 'common/constants/user';
import ChangeUserPasswordForm from 'components/user/user-data-form/ChangeUserPasswordForm';
import { IUser } from 'common/interfaces/iuser';
import { useUserActions } from 'actions/user-actions';

const ChangeUserPasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const userId = params && params.userId ? params.userId : undefined;
  const error = useAppSelector((store) => store.updateUserReducer.error);
  const loggedInUser = useAppSelector((store) => store.appReducer.loggedInUser);
  const roleIdMap = useAppSelector((store) => store.userReducer.roleIdMap);
  const [_user, setUser] = useState<IUser>();
  const { loadUserDetailsByUuId, resetUpdateUserForm, setUpdateError, loadAllRoles } = useUserActions();

  useEffect(() => {
    if (loggedInUser && loggedInUser?.roleId && roleIdMap && _user) {
      const userRole = roleIdMap[_user.roleId];
      const loggedInUserRole = roleIdMap[loggedInUser.roleId];

      if (
        userRole.roleName === UserRoleTypeEnum.FRANCHISEE_ADMIN &&
        loggedInUserRole.priority < UserRolePriority[UserRoleTypeEnum.ADMIN]
      ) {
        setUpdateError('Not permitted');
      } else if (
        userRole.priority < UserRolePriority[UserRoleTypeEnum.FRANCHISEE_ADMIN] &&
        loggedInUserRole.priority < UserRolePriority[UserRoleTypeEnum.FRANCHISEE_ADMIN]
      ) {
        setUpdateError('Not permitted');
      } else if (userRole.priority >= UserRolePriority[UserRoleTypeEnum.MASTER_ADMIN]) {
        setUpdateError('Not permitted');
      }
    }
  }, [loggedInUser, roleIdMap, _user]);

  const _loadUser = async (userId: string) => {
    setUpdateError(undefined);
    const user = await loadUserDetailsByUuId(userId);
    const userData = user?.data;
    if (!userData || !userData.id) {
      setUpdateError('User not found');
    } else if (userData && (!roleIdMap || !roleIdMap[userData.roleId])) {
      loadAllRoles();
    }
    setUser(user?.data);
  };
  useEffect(() => {
    console.log('Mounted storeScreen.....1', userId);
    resetUpdateUserForm();
    if (userId) {
      _loadUser(userId);
    }
  }, [userId]);
  const _handleCancel = () => {
    navigate('/users');
  };

  return (
    <section style={{ marginBottom: '80px' }}>
      <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} gap={2} className="pageTitleTitleContainer">
        <h2 className="pageTitle">{t('page.changePassword')}</h2>
      </Box>
      {error ? (
        <Box>
          <Alert severity="error">{error.msg} </Alert>
          <Button
            // disabled={updating}
            variant="contained"
            onClick={_handleCancel}
            style={{ marginTop: '30px' }}
            // loading={updating}
            color="error"
          >
            Back
          </Button>
        </Box>
      ) : null}
      {_user && !error ? <ChangeUserPasswordForm userData={_user} /> : null}
    </section>
  );
};

export default ChangeUserPasswordPage;
